<form class="create-invoice-modal" [formGroup]="form" novalidate>
  <div style="padding: 10px; padding-top: 0">
    <h4>Add New Client</h4>

    <div style="display: flex; flex-direction: column; gap: 16px">
      <div
        class="custom_option_picker_with_absolute_label custom-input_field_withoutIcon"
      >
        <span class="custom_option_picker-label"> Target </span>
        <input
          class="custom-input_field"
          matInput
          #newTarget
          formControlName="newTarget"
          type="text"
        />
      </div>
      <div
        class="custom_option_picker_with_absolute_label custom-input_field_withoutIcon"
      >
        <span class="custom_option_picker-label"> Description </span>
        <input
          class="custom-input_field"
          matInput
          #description
          formControlName="description"
          type="text"
        />
      </div>
      <div
        class="custom_option_picker_with_absolute_label custom-input_field_withoutIcon"
      >
        <span class="custom_option_picker-label"> Target URL </span>
        <input
          class="custom-input_field"
          matInput
          formControlName="targetUrl"
          type="text"
        />
      </div>
      <div
        class="custom_option_picker_with_absolute_label custom-input_field_withoutIcon"
        *ngIf="!data?.prefillAndHide?.targetShop"
      >
        <span class="custom_option_picker-label"> Copy From Target </span>
        <input
          class="custom-input_field"
          matInput
          #targetShop
          formControlName="targetShop"
          type="text"
        />
      </div>
      <div
        class="custom_option_picker_with_absolute_label"
        *ngIf="!data?.prefillAndHide?.role"
      >
        <span class="custom_option_picker-label"> Role </span>
        <div class="custom_option_picker">
          <mat-form-field
            class="create-invoice-modal-select-option"
            style="width: 100%"
          >
            <mat-select formControlName="role">
              <mat-option *ngFor="let l of roleList" [value]="l">
                {{ l }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="custom_option_picker_with_absolute_label">
        <span class="custom_option_picker-label"> Country </span>
        <div class="custom_option_picker">
          <mat-form-field
            class="create-invoice-modal-select-option"
            style="width: 100%"
          >
            <mat-select formControlName="country">
              <mat-option
                *ngFor="let country of filteredCountries"
                [value]="country.name"
              >
                {{ country.name }}
              </mat-option>
              <div class="select-search-input select-search-input-bottom">
                <input
                  placeholder="Search country"
                  (keyup)="searchCountries($event)"
                  (keydown.space)="$event.stopPropagation()"
                />
              </div>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="custom_option_picker_with_absolute_label">
        <span class="custom_option_picker-label"> Timezone </span>
        <div class="custom_option_picker">
          <mat-form-field
            class="create-invoice-modal-select-option"
            style="width: 100%"
          >
            <mat-select formControlName="timezone">
              <mat-option
                *ngFor="let timezone of timezoneList"
                [value]="timezone.name"
              >
                {{ timezone.name }} (UTC {{ timezone.offset }})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div
        class="custom_option_picker_with_absolute_label"
        *ngIf="!whiteLabelTarget"
      >
        <span class="custom_option_picker-label"> Region </span>
        <div class="custom_option_picker">
          <mat-form-field
            class="create-invoice-modal-select-option"
            style="width: 100%"
          >
            <mat-select formControlName="region">
              <mat-option *ngFor="let region of regions" [value]="region.value">
                {{ region.description }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="custom_option_picker_with_absolute_label">
        <span class="custom_option_picker-label"> Setup Model </span>
        <div class="custom_option_picker">
          <mat-form-field
            class="create-invoice-modal-select-option"
            style="width: 100%"
          >
            <mat-select formControlName="setupMode">
              <mat-option value="dashboard_only"> Dashboard Only </mat-option>
              <mat-option value="full"> Full Setup </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <span class="span-description">
        <small>
          Note: If you select "Full Setup", the system will automatically create
          a new Github repository, Azure DevOps project, and Jenkins job for
          this client.
        </small>
      </span>
      <mat-checkbox [checked]="startIntegration" (change)="startIntegration = $event.checked" [disabled]="submitting">
        Start Integration
      </mat-checkbox>
      <small class="span-description">Choose how to create experiments after adding this client.</small>
      <p *ngIf="submitError" role="alert">{{ submitError }}</p>
    </div>
  </div>
</form>

<div mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()" [disabled]="submitting">Cancel</button>
  <button
    type="submit"
    mat-button
    color="primary"
    (click)="addClient()"
    [disabled]="!form.valid || submitting"
  >
    {{ submitting ? 'Adding client…' : 'Add Client' }}
  </button>
</div>
